import React from 'react';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import { MOMENT_SPANISH_LANG } from '../../../config/defaults';
import removeAccents from '../../../services/removeAccents';
import getTimeDifference from '../../../services/getTimeDiference';

import Table from './Table';

moment.locale('es', MOMENT_SPANISH_LANG);

class Viewers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			exportableList: [],
		};

		this.loadViewers = this.loadViewers.bind(this);
		this.listener = () => {};
	}
	componentDidMount() {
		this.loadViewers();
	}
	componentWillUnmount() {
		this.listener();
	}

	exportToExcel() {
		const { exportableList = [] } = this.state;
		const { name } = this.props.event;

		const data = exportableList.map((row) => ({
			Nombre: row.name,
			Correo: row.email,
			'Hora de Ingreso': row.date_in,
			'Hora de Salida': row.date_out,
			Duración: row.duration,
		}));

		const worksheet = XLSX.utils.json_to_sheet(data);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Espectadores');
		const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
		saveAs(blob, `Espectadores ${removeAccents(name)}.xlsx`);
	}

	loadViewers() {
		const self = this,
			eventId = this.props.event.id;

		this.listener = this.props.firebase.getRooms(
			'events',
			eventId,
			'viewers',
			{ field: 'time_in', type: 'asc' },
			(docs) => {
				const list = [],
					exportableList = [];

				docs.forEach(async (doc) => {
					const subscriber = doc.data();

					subscriber.id = doc.id;

					if (subscriber.time_out) {
						let _strDateIn = [],
							_strDateOut = [],
							_strDateDuration = [];

						for (var objSubscriber in subscriber) {
							if (objSubscriber.startsWith('r_')) {
								const _dateIn = moment
										.utc(subscriber[objSubscriber].in)
										.local(),
									_dateOut = moment.utc(subscriber[objSubscriber].out).local(),
									__dateIn = _dateIn.format('YYYY-MM-DD HH:mm:ss'),
									__dateOut = _dateOut.format('YYYY-MM-DD HH:mm:ss'),
									__duration = getTimeDifference(_dateIn, _dateOut);

								if (subscriber.name === '' || subscriber.name === null) {
									const user = await self.props.firebase.db
										.collection('events')
										.doc(eventId)
										.collection('subscribers')
										.where('uid', 'array-contains', subscriber.id)
										.get();

									if (!user.empty) {
										user.forEach((_subscriber) => {
											subscriber.name = _subscriber.data().displayName;
											subscriber.email = _subscriber.data().email;
										});
									}
								}

								_strDateIn.push(
									<p key={subscriber[objSubscriber].in}>{__dateIn}</p>
								);
								_strDateOut.push(
									<p key={subscriber[objSubscriber].out}>{__dateOut}</p>
								);
								_strDateDuration.push(
									<p key={subscriber[objSubscriber].in}>{__duration}</p>
								);

								exportableList.push({
									name: subscriber.name,
									email: subscriber.email,
									date_in: __dateIn,
									date_out: __dateOut,
									duration: __duration,
								});
							}
						}

						_strDateIn.sort((a, b) => {
							if (a.key > b.key) {
								return 1;
							}

							return -1;
						});

						subscriber.date_in = _strDateIn;
						subscriber.date_out = _strDateOut;
						subscriber.duration = _strDateDuration;
					} else {
						subscriber.date_in = moment
							.unix(subscriber.time_in)
							.format('YYYY-MM-DD HH:mm:ss');
						subscriber.date_out = '--';
						subscriber.duration = '--';

						exportableList.push({
							name: subscriber.name,
							email: subscriber.email,
							date_in: subscriber.date_in,
							date_out: subscriber.date_out,
							duration: subscriber.duration,
						});
					}
					list.push(subscriber);
				});

				self.setState({ list: list, isLoading: false, exportableList });
			}
		);
	}
	render() {
		const { list = [] } = this.state;
		return (
			<div className="row row-sm">
				<div className="col-md-12">
					<div className="card card-body">
						<div className="viewers-header">
							<h4>Suscriptores que ingresaron a la página web</h4>
							<div className="col-md-2 tx-center">
								<h6>En total ingresaron</h6>
								<h1>
									{list.length}{' '}
									<small>Persona{list.length !== 1 ? 's' : ''}</small>
								</h1>
							</div>
						</div>
						<div className="row">
							<Table rows={list} />
						</div>

					<div className="col-md-12 mg-t-20 tx-right">
						<button
							className="btn btn-az-primary"
							disabled={this.state.isLoading}
							onClick={() => this.exportToExcel()}
						>
							<i className="fas fa-file-excel"></i> Exportar todos los
							Registros
						</button>
					</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Viewers;
